import React, { Component } from 'react';

export class WeftMark extends Component {
  render() {
    return (
        <div className={'logo-container'}>
          <a href={'/'} className={'logo-link'}>
            <svg className={'weft-svg'} viewBox={'0 0 675 469.88'}>
          <polygon
            className={'line-through'}
            points={'0,147.336 0,196.053 82.691,196.053 78.058,147.336'}
          />
          <polygon
            className={'line-through'}
            points={'171.301,147.336 175.941,196.053 377.521,196.053 369.434,147.336'}
          />
          <polygon
            className={'line-through'}
            points={'458.282,147.333 467.617,196.053 675,196.053 675,147.333 '}
          />

          <path
            className={'w'}
            d={'M607.527,0.37h-54.547c-0.956,45.974-2.271,88.236-5.118,130.482h54.021C605.263,79.688,605.368,34.48,607.527,0.37'}
          />
          <path
            className={'w'}
            d={'M594.916,211.922h-53.767c-8.21,56.767-22.162,89.267-46.666,90.694C440.224,305.769,453.19,2.325,349.73,0.362c-47.456,0.898-70.41,61.044-86.6,130.119h49.91c7.603-37.225,17.372-60.197,36.69-61.112c63.119,2.993,24.358,285.997,140.767,285.997C555.402,355.367,582.676,292.634,594.916,211.922'}
          />
          <path
            className={'w'}
            d={'M246.718,211.923c-11.359,54.465-22.277,91.898-43.029,90.691C154.631,299.763,147.868,147.434,144.804,0H90.257c6.657,105.117-6.237,355.367,117.419,355.367c60.33,0,78.98-69.794,91.735-143.445H246.718z'}
          />

          <path
            className={'weft'}
            d={'M291.276,450.224h0.494l11.25-36.346h13.475l-17.307,54.519h-14.341l-9.89-35.975h-0.495l-9.89,35.975h-14.463l-17.308-54.519h14.712l11.373,36.346h0.495l9.89-36.346h11.991L291.276,450.224z'}
          />
          <path
            className={'weft'}
            d={'M374.219,450.595c-2.844,12.115-12.24,19.285-26.209,19.285c-16.813,0-28.929-10.756-28.929-27.939c0-17.185,12.24-29.546,28.558-29.546c17.802,0,26.951,12.361,26.951,27.197v5.315h-40.92c0.494,8.036,6.799,13.724,14.835,13.724c7.294,0,11.621-3.092,13.722-9.273L374.219,450.595z M360.125,435.637c-0.495-6.305-4.327-12.363-12.61-12.363c-8.16,0-12.239,5.563-13.6,12.363H360.125z'}
          />
          <path
            className={'weft'}
            d={'M380.146,424.263v-10.385h8.036v-4.575c0-12.732,7.665-20.273,19.904-20.273c9.89,0,15.947,4.698,18.296,13.351l-9.519,3.09c-1.236-3.461-3.584-5.81-7.417-5.81c-4.574,0-6.552,3.461-6.552,8.529v5.688h14.588v10.385h-14.588v44.134h-14.711v-44.134H380.146z'}
          />
          <path
            className={'weft'}
            d={'M433.051,424.263h-7.789v-8.778l3.709-0.619c5.317-0.864,6.8-3.585,8.036-8.654l1.731-7.417h9.024v15.083h14.835v10.385h-14.835v26.949c0,4.7,2.102,6.8,6.552,6.8c2.967,0,6.058-1.112,9.272-2.595v9.766c-3.956,2.968-8.406,4.698-15.082,4.698c-8.407,0-15.453-3.707-15.453-15.329V424.263z'}
          />
        </svg>
        </a>
      </div>
    );
  }
}
